import gigApiFetcher from "./common/fetching";
import { IndustrialExperienceDto } from "../api/models/industrialExperience";

export const fetchIndustrialExperienceList = async (query: string | undefined, accessToken: string | null): Promise<IndustrialExperienceDto[]> => {
    const queryString = query ? `?searchTerm=${query}` : "";

    const response = await gigApiFetcher<never, IndustrialExperienceDto[]>({
        path: `api/industrial-experience${queryString}`,
        method: "GET",
        body: undefined,
        token: accessToken || undefined,
    });

    return response;
};

export const fetchIndustrialExperienceOptions = async (query: string, accessToken: string | null) => {
    const industrialExperienceResponse = await fetchIndustrialExperienceList(query, accessToken);
    
    return industrialExperienceResponse
        .map(industrialExperience => ({
            value: industrialExperience.id,
            label: industrialExperience.name,
        }));
};